module.exports = __webpack_public_path__ + "img/review-7.341de1e2.png";